/**
 * Recover from a stale-chunk 404 after a deploy.
 *
 * Chunk filenames are content-hashed, so a deploy publishes a new set and (with
 * `s3 sync --delete` disabled for `assets/js/`) leaves the old set in place. A
 * tab opened before a deploy still 404s if it navigates into a route whose chunk
 * was pruned by a later cleanup. Vite fires `vite:preloadError` for that failed
 * dynamic import; without a handler the `import()` rejects, React Suspense never
 * resolves, and the user is stranded on the route's fallback loader.
 *
 * Reload once to pick up the current index.html and its new chunk URLs. The
 * timestamp guard stops a genuinely broken deploy from becoming a reload loop,
 * while still letting a later deploy in the same session reload again.
 */
const RELOAD_KEY = 'osano:chunkReloadAt';
const RELOAD_COOLDOWN_MS = 10000;

window.addEventListener('vite:preloadError', event => {
    event.preventDefault();

    try {
        const last = Number(sessionStorage.getItem(RELOAD_KEY)) || 0;
        if (Date.now() - last < RELOAD_COOLDOWN_MS) return;
        sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
    } catch {
        // sessionStorage unavailable (private mode / disabled). Reload without
        // the loop guard rather than leave the user on the fallback loader.
    }

    window.location.reload();
});
